export enum Service {
  MG = 'mg',
  Ulozto = 'ulozto',
  Pinkfile = 'pinkfile',
}
